
import SvgWrapper from './../../../../zviz2/zviz/components/svg/wrapper';
import {default as Group, Controller as GroupController} from './../../../../zviz2/zviz/components/group';

import BlueprintLoadingSvg from './../../../../components/elements/loader/svg';
import Rectangle from './../../../../zviz2/zviz/components/rectangle';
import {extend, cloneObject, proxy} from './../../../../zviz2/zviz/functions';
import state from './../../../../zviz2/zviz/state';

import Defs from './components/defs';
import MapBox from './components/box';
import MapData from './components/mapdata';

import svgPanZoom from './../../../../zviz2/vendor/svgPanZoom/minified';
import zoomControls from './components/zoom';

class Controller extends GroupController{

    constructor(parent, blueprint){

        super(parent, blueprint);

        this.panZoomInstance = null;
        this.timerId = null;
        this.panTime = 0;

    }

    init(renderer){
        super.init(renderer);
        if(this.data.zoom){
            let self = this;
            this.timerId = setTimeout(proxy([this, this.setPanZoom]), 500);
        }
    }

    remove(renderer, removeFromParent=true){
        clearTimeout(this.timerId);
        if(this.panZoomInstance){
            this.panZoomInstance.destroy();
        }
        super.remove(renderer, removeFromParent);
    }

    setPanZoom(){
        // using id, because IE9 doesn't like getElementsByClassName in an svg
        let container = document.getElementById('panZoomGroup', this.renderOutput.result);
        if(! container){
            // try again
            this.timerId = setTimeout(proxy([this, this.setPanZoom]), 500);
            return;
        }

        this.panZoomInstance = svgPanZoom(this.getByUid('svgMap').renderOutput.result, {
            viewportSelector: container,
            minZoom: 0.3,
            zoomScaleSensitivity: 0.5,
            mouseWheelZoomEnabled: false,
            onZoom: proxy([this, this.onZoom]),
            onPan: proxy([this, this.onPan]),
            dblClickZoomEnabled: false,
            fit: false,
            center: false,
            preventMouseEventsDefault: false,
            preventMouseMoveEventsDefault: true,
            /*,
            panEnabled: true,
            controlIconsEnabled: false,
            zoomEnabled: true,
            dblClickZoomEnabled: true,
            mouseWheelZoomEnabled: true,
            preventMouseEventsDefault: true,
            zoomScaleSensitivity: 0.2,
            minZoom: 0.5,
            maxZoom: 10,
            fit: true,
            contain: false,
            center: true,
            refreshRate: 'auto',
            beforeZoom: function () { },
            onZoom: function () { },
            beforePan: function () { },
            onPan: function () { },
            customEventsHandler: function(){},
            eventsListenerElement: null*/
        });
    }

    zoomIn(){
        if(this.panZoomInstance){
            this.panZoomInstance.zoomIn();
        }
    }

    zoomOut(){
        if(this.panZoomInstance){
            this.panZoomInstance.zoomOut();
        }
    }

    resetZoom(){
        if(this.panZoomInstance){
            this.panZoomInstance.resetZoom();
            this.panZoomInstance.resetPan();
        }
    }

    onZoom(zoomScale){
        clearTimeout(this.timerId);
        this.timerId = setTimeout(proxy([this, function(){ this.panZoomInstance.pan(state.get('map.zoomPan')||{x:0, y:0}); }]), 100);
        state.set('map.zoomScale', zoomScale);
    }

    onPan(position){
        state.set('map.zoomPan', position);
        this.panTime = Date.now();
        // if(zoom && zoom.renderOutput && zoom.renderOutput.result){
        //     state.set('map.zoomTransform', zoom.renderOutput.result.getAttribute('transform') || '');
        // }
    }

    getSize(type='h'){
        return this.getByUid('svgMap').getSize(type);
    }

    getChildren(){


    }

    setHeight(height){

        this.getByUid('svgMap').setHeight(height);
    } 

}



let Blueprint = SvgWrapper({
    type: Controller,
    uid: 'map',
    properties: { 
        data: {
            selected: (ctrl) => ( ctrl.getByUid('svgMap').data.selected ),
            highlight: (ctrl) => ( ctrl.getByUid('svgMap').data.highlight ),
            fadeOut: (ctrl) => ( ctrl.getByUid('svgMap').data.fadeOut ),
            width: (ctrl) => ( ctrl.getSize('w') ),
            // height: (ctrl) => ( ctrl.getSize('h') ),
            height: (ctrl) => ( state.get('windowSize.width')<700? 250: 600),
            autoHeight: (ctrl) => (ctrl.getByUid('svgMap').data.height == 'auto'),
            maxScale: (ctrl) => ( ctrl.getByUid('svgMap').data.maxScale ),
            colors: (ctrl) => ( ctrl.getByUid('svgMap').data.colors ),
            title: (ctrl) => ( ctrl.getByUid('svgMap').data.title ),
            zoom: (ctrl) => ( ctrl.getByUid('svgMap').data.zoom )
        },
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'windowSize.width') ),
    ],
    children: [
        
        (parent) => (extend({
            properties: {
                attributes: {
                    x: '0',
                    y: '0',
                    width: parent.getSize('w') + 'px',
                    height: parent.getSize('h') + 'px',
                },
                style: {
                    fill: 'url(#mapBgGradient)',
                    stroke: 'transparent'
                }
            }
        }, Rectangle) ),

        // zoom group
        (parent) => (extend({
            uid: 'mapZoomGroup',
            properties: {
                attributes: {
                    'id': 'panZoomGroup',
                },
                style: {

                }
            },
            children: []
        }, Group) ),

        // zoom group
        (parent) => (extend({
            properties: {
                attributes: {
                    'clip-path': 'url(#mapClipPath)'
                },
                style: {
                    'clip-path': 'url(#mapClipPath)'
                },
                data: {
                    data: cloneObject(parent.data)
                }
            },

            children: [

                extend({
                    properties: {
                        data: cloneObject(parent.data)
                    },
                    responders: [
                        {name: 'height', callback: [parent, parent.setHeight] }
                    ],
                }, MapBox),

                extend({
                    properties: {
                        data: {
                            width: parent.data.width,
                            height: parent.data.height,
                            selected: parent.data.selected
                        }
                    },
                }, MapData)
            
            ]

        }, Group) ),

        // gui/controls
        (parent) => ( (parent.data.zoom == true)? extend({
            properties: {
                transform: {
                    position: {
                        x: parent.data.width - 35,
                        y: parent.data.height - 130
                    }
                }
            },
            responders: [
                {name: 'zoomIn', callback: [parent, parent.zoomIn] },
                {name: 'zoomOut', callback: [parent, parent.zoomOut] },
                {name: 'reset', callback: [parent, parent.resetZoom] }
            ]
        }, zoomControls): [] )

    ],
    // events: {
    //     mouseover: (event, ctrl) => ( ctrl.setHover(true) ),
    //     mouseout: (event, ctrl) => ( ctrl.setHover(false) )
    // }    
}, 

// extension of the svg wrapper
{
    uid: 'svgMap',
    properties: {
        data: {
            width: 'auto',
            height: 'auto',
            fadeOut: false,
            selected: false,
            highlight: false,
            maxScale: 1000,
            zoom: false,
            language: 'english',
            colors: {
                normal: [180,180,180],
                highlight: [255, 0, 0]
            },
            title: false
        },
        
    },
    children: [
        (parent) => (extend({
            properties: {
                data: {
                    width: parent.getWidth(),
                    height: parent.getHeight(),
                    countryColor: parent.data.colors.normal,
                    highlightColor: parent.data.colors.highlight
                },
            }
        }, Defs) ),

        []
    ]
});


let Loader = extend({
    properties: {
        data: {
            size: 30,
            width: (ctrl) => ( ctrl.getByUid('svgMap').width ),
            height: (ctrl) => ( ctrl.getByUid('svgMap').height ),
        }
    }
}, BlueprintLoadingSvg);

export default Blueprint;
// export {PublicInterface};  